module.exports = __webpack_public_path__ + "img/mapfre-sigorta.a165590c.png";